export const REST_BREAK_LENGTH_MINUTES = 10;
export const MEAL_BREAK_LENGTH_MINUTES = 30;
export const BREAK_VERY_LATE_THRESHOLD_MINUTES = 15;
export const UPCOMING_REST_THRESHOLD_MINUTES = 15;
export const UPCOMING_BREAK_THRESHOLD_MINUTES = 15;
